import useSWR from 'swr'
import { jsonGetFetcher } from '../src/fetchers'

function useActivity (token, activityId) {
  let url = `${process.env.API}/activities/${activityId}`

  const defaultHook = {
    isLoading: false,
    activity: {
      id: null,
      challenges: []
    },
    error: false
  }
  
  let { data, error, mutate, isLoading } = useSWR(activityId && activityId !== 'new' && token ? [url, token] : null, jsonGetFetcher)
  
  if (!data && !error) {
    return defaultHook
  }

  if (error) {
    if (error.status === 401) {
      // user hook will handle logout, just return empty data
      return { activity: null, isLoading }
    }
    console.error(error)
    return { activity: { challenges: [] }, errorStatus: error.status, error: error.message, isLoading }
  }

  return {
    isLoading,
    activity: data,
    mutate
  }
}

export default useActivity
